import { Box, type BoxProps, LoadingOverlay } from '@mantine/core'
import { clsx } from 'clsx'
import { usePathname } from 'next/navigation'
import { useEffect, type PropsWithChildren } from 'react'

import { useAnalytics } from '@flecto/analytics'

import { PageActions } from './Actions'
import { PageBack } from './Back'
import { PageBreadcrumb } from './Breadcrumb'
import { PageClose } from './Close'
import { PageContent } from './Content'
import { PageDescription } from './Description'
import { PageHeader } from './Header'
import { useFilterChildren } from './hooks/useFilterChildren'
import { PageSidebar } from './Sidebar'
import classes from './styles.module.css'
import { PageTitle } from './Title'

export type PageProps = PropsWithChildren<BoxProps> & {
  withLoading?: boolean
  withContainer?: boolean
}

export function Page({
  children,
  className,
  withLoading = false,
  withContainer = false,
  ...props
}: PageProps) {
  const track = useAnalytics('segment')
  const pathname = usePathname()

  const { headerChildren, contentChildren } = useFilterChildren(children)

  const pageWrapperClasses = clsx(classes.pageWrapper, className, {
    [classes.pageWithContainer]: withContainer,
  })

  useEffect(() => {
    track('PAGE__VIEW', { path: pathname })
  }, [pathname])

  return (
    <Box {...props} className={pageWrapperClasses}>
      {headerChildren && <PageHeader>{headerChildren}</PageHeader>}
      {contentChildren}
      <LoadingOverlay visible={withLoading} />
    </Box>
  )
}

Page.Breadcrumb = PageBreadcrumb
Page.Title = PageTitle
Page.Back = PageBack
Page.Close = PageClose
Page.Actions = PageActions
Page.Description = PageDescription
Page.Content = PageContent
Page.Sidebar = PageSidebar

